<div
    class="sidebar-area bg-white transition"
    [ngClass]="{'active': isToggled}"
>
    <div class="logo bg-white">
        <img ngSrc="assets/logo-white.png" alt="AI Price Estimator" class="sidebar-logo" width="1920" height="1080" priority>
        <div class="logo-text">
            <span class="logo-title">AI Price</span>
            <span class="logo-subtitle">Estimator</span>
        </div>
    </div>
    <div
        class="burger-menu transition cursor-pointer"
        [ngClass]="{'active': isToggled}"
        (click)="toggle()"
    >
        <span class="top-bar transition bg-dark d-block"></span>
        <span class="middle-bar transition bg-dark d-block"></span>
        <span class="bottom-bar transition bg-dark d-block"></span>
    </div>
    <br><br><br>
    <div class="sidebar-inner">
        <div class="sidebar-menu">
            <mat-accordion>
                <a routerLink="/main" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <i-feather name="home"></i-feather>
                <span class="title">
                    Home
                </span>
                </a>
                <span class="sub-title text-body">
                    Apps
                </span>

                <a routerLink="/main/apps/estimator-dual-photo" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <i-feather name="share-2"></i-feather>
                  <span class="title">
                      Estimator
                  </span>
                </a>
                  <a routerLink="/main/apps/train" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <i-feather name="settings"></i-feather>
                  <span class="title">
                      AI Training
                  </span>
                </a>
                <span class="sub-title text-body">
                    Products
                </span>
                <a routerLink="/main/apps/sessions" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <i-feather name="layers"></i-feather>
                  <span class="title">
                    My Sessions
                  </span>
                </a>
                <a routerLink="/main/apps/shared-sessions" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <i-feather name="users"></i-feather>
                  <span class="title">
                    Shared Sessions
                  </span>
                </a>
                <a routerLink="/main/stats" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <i-feather name="bar-chart-2"></i-feather>
                    <span class="title">
                        Uploaded Products
                    </span>
                </a>
            <div *ngIf="isAdmin">
                <span class="sub-title text-body">
                    Admin
                </span>
                <a routerLink="/main/users" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <i-feather name="users"></i-feather>
                    <span class="title">
                        Users
                    </span>
                </a>
                <a routerLink="/main/add-user" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <i-feather name="user-plus"></i-feather>
                    <span class="title">
                        Add New User
                    </span>
                </a>
                <!-- <a routerLink="/main/stats" style="font-size: 16px;" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <i-feather name="bar-chart-2"></i-feather>
                    <span class="title">
                        Products
                    </span>
                </a> -->
            </div>
            </mat-accordion>
        </div>
    </div>
</div>
